import React from 'react';
import Pencil from '@uber/base-icons/pencil';
import TrashCan from '@uber/base-icons/trash-can';
import { type Theme, useStyletron } from 'baseui';
import { Button, KIND as BUTTON_KIND, SIZE as BUTTON_SIZE } from 'baseui/button';
import { StatefulTooltip } from 'baseui/tooltip';
import { RELATIONSHIP_CONSTANTS } from '../constants';
import { RELATIONSHIP_TOOLTIP_OVERRIDES } from '../overrides';
type RelationshipActionButtonsPropsT = {
  relationshipId: string;
  onEdit: (relationshipId: string) => void;
  onDelete: (relationshipId: string) => void;
  showTooltip?: boolean;
};
const ACTION_BUTTON_OVERRIDES = {
  BaseButton: {
    style: ({
      $theme
    }: {
      $theme: Theme;
    }) => ({
      boxSizing: 'border-box',
      height: $theme.sizing.scale850,
      width: $theme.sizing.scale850
    })
  }
};
export const RelationshipActionButtons = ({
  relationshipId,
  onEdit,
  onDelete,
  showTooltip
}: RelationshipActionButtonsPropsT) => {
  const [css, theme] = useStyletron();
  const editButton = <Button aria-label={RELATIONSHIP_CONSTANTS.EDIT_TOOLTIP} kind={BUTTON_KIND.secondary} size={BUTTON_SIZE.xSmall} onClick={() => onEdit(relationshipId)} overrides={ACTION_BUTTON_OVERRIDES}>
      <Pencil size={14} />
    </Button>;
  const deleteButton = <Button aria-label={RELATIONSHIP_CONSTANTS.DELETE_TOOLTIP} kind={BUTTON_KIND.secondary} size={BUTTON_SIZE.xSmall} onClick={() => onDelete(relationshipId)} overrides={ACTION_BUTTON_OVERRIDES}>
      <TrashCan size={14} />
    </Button>;
  return <div className={css({
    display: 'flex',
    alignItems: 'center',
    gap: theme.sizing.scale200,
    flexShrink: 0
  })}>
      {showTooltip ? <StatefulTooltip content={RELATIONSHIP_CONSTANTS.EDIT_TOOLTIP} overrides={RELATIONSHIP_TOOLTIP_OVERRIDES} showArrow>
          {editButton}
        </StatefulTooltip> : editButton}
      {showTooltip ? <StatefulTooltip content={RELATIONSHIP_CONSTANTS.DELETE_TOOLTIP} overrides={RELATIONSHIP_TOOLTIP_OVERRIDES} showArrow>
          {deleteButton}
        </StatefulTooltip> : deleteButton}
    </div>;
};